// @ts-check
import produce from 'immer';
import * as edmEditor from './edmEditor';
import * as edxEditor from './edxEditor';
import pathUtil from '../../../../../../../utils/pathUtil';

function reducer(state, action) {
  var editor = state.job.outputType === 'bi-universe' ? edmEditor : edxEditor;

  switch (action.type) {
    case 'insert_spreadsheet':
      return insertSpreadsheet(state, action.payload, editor);

    case 'change_spreadsheetSource':
      return changeSpreadsheetSource(state, action.payload);

    case 'remove_spreadsheet':
      return removeSpreadsheet(state, action.payload, editor);

    case 'update_relationship':
      return updateRelationship(state, action.payload, editor);

    case 'remove_relationship':
      return removeRelationship(state, action.payload, editor);

    default:
      return state;
  }
}

var insertSpreadsheet = function insertSpreadsheet(state, _ref, editor) {
  var src = _ref.src,
      schema = _ref.schema,
      id = _ref.id;
  var result = produce(state, function (draft) {
    draft.job.lastId = id;
    /** @type {import("./types").DasSubdocumentParam} */

    var subdocumentParam = {
      id: getNextId(draft.job),
      name: pathUtil.getFileCaption(src) + 'Path',
      value: src,
      type: 'string'
    };
    draft.job.parameters.push(subdocumentParam);
    var csvUrl = {
      id: id,
      src: src,
      elementName: 'csvUrl',
      fields: schema.Fields.map(function (field) {
        return {
          id: getNextId(draft.job),
          name: field.Name,
          type: field.Type
        };
      }),
      valueCoertion: {
        // default values
        map: [{
          src: 'empty-date',
          dest: 'null'
        }, {
          src: 'invalid-date',
          dest: 'null'
        }, {
          src: 'empty-numeric',
          dest: 'null'
        }, {
          src: 'invalid-numeric',
          dest: 'null'
        }]
      },
      inParam: {
        id: getNextId(draft.job),
        name: 'Override path',
        src: subdocumentParam.id,
        isOptional: 'true'
      }
    };
    draft.job.dataSources.push(csvUrl);
    editor.addToOutput(draft.job, csvUrl);
    var nextPosition = getNextCorrectItemPosition(20, draft.job.diagram.items);
    draft.job.diagram.items.push({
      id: csvUrl.id,
      x: nextPosition,
      y: nextPosition,
      height: 200,
      width: 150,
      elementName: 'diagramCsvUrl'
    });
    nextPosition = getNextCorrectItemPosition(20, draft.job.diagram.items);
    draft.job.diagram.items.push({
      id: subdocumentParam.id,
      x: nextPosition,
      y: nextPosition,
      height: 35,
      width: 150,
      elementName: 'diagramSubdocumentParam '
    });
  });
  return result;
};

var getNextId = function getNextId(job) {
  var nextId = parseInt(job.lastId) + 1;
  job.lastId = nextId.toString();
  return job.lastId;
};

var getNextCorrectItemPosition = function getNextCorrectItemPosition(step, items) {
  var current = 10;

  while (items.some(function (e) {
    return parseFloat(e.x) === current && parseFloat(e.y) === current;
  })) {
    current += step;
  }

  return current.toString();
};

var changeSpreadsheetSource = function changeSpreadsheetSource(state, _ref2) {
  var dataSourceId = _ref2.dataSourceId,
      src = _ref2.src;
  return produce(state, function (draft) {
    var dataSource = draft.job.dataSources.find(function (dataSource) {
      return dataSource.id === dataSourceId;
    });
    var diagramParameter = draft.job.parameters.find(function (parameter) {
      return parameter.id === dataSource.inParam.src;
    });
    if (diagramParameter) diagramParameter.value = src;
    dataSource.src = src;
  });
};

var removeSpreadsheet = function removeSpreadsheet(state, id, editor) {
  return produce(state, function (draft) {
    var index = draft.job.dataSources.findIndex(function (dataSource) {
      return dataSource.id === id;
    });
    editor.removeFromOutput(draft.job, id);
    var overridePathParamId = draft.job.dataSources[index].inParam.src;
    var parameterIndex = draft.job.parameters.findIndex(function (parameter) {
      return parameter.id === overridePathParamId;
    });
    if (parameterIndex != -1) draft.job.parameters.splice(parameterIndex, 1);
    draft.job.dataSources.splice(index, 1);
    draft.job.diagram.items = draft.job.diagram.items.filter(function (diagram) {
      return diagram.id !== id && diagram.id !== overridePathParamId;
    });
  });
};

var updateRelationship = function updateRelationship(state, relationshipValues, editor) {
  return produce(state, function (draft) {
    editor.updateRelationship(draft.job, relationshipValues);
  });
};

var removeRelationship = function removeRelationship(state, relationshipId, editor) {
  return produce(state, function (draft) {
    editor.removeRelationship(draft.job, relationshipId);
  });
};

export default reducer;